import { FC } from "react";

import { FormDateRangeWithScarcity, FormDateRangeWithScarcityProps } from "@/forms-design-system/FormDate";

type ThemedTicketingFormDateProps = FormDateRangeWithScarcityProps;

export const ThemedTicketingFormDate: FC<ThemedTicketingFormDateProps> = ({ ...rest }) => {
  return <FormDateRangeWithScarcity {...rest} />;
};
